import { render, staticRenderFns } from "./FinalReviewList.vue?vue&type=template&id=632bc50c"
import script from "./FinalReviewList.vue?vue&type=script&lang=js"
export * from "./FinalReviewList.vue?vue&type=script&lang=js"
import style0 from "./FinalReviewList.vue?vue&type=style&index=0&id=632bc50c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports